var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.27344,
    y: 1.01953,
    width: 21.3974,
    height: 21.3974,
    rx: 3.56624,
    fill: "#243677",
    fillOpacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.09513,
    y: 0.841219,
    width: 21.7541,
    height: 21.7541,
    rx: 3.74455,
    stroke: "#243677",
    strokeOpacity: 0.16,
    strokeWidth: 0.356624
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75208 8.56458C9.42393 8.56458 9.15792 8.8306 9.15792 9.15875C9.15792 9.4869 9.42393 9.75292 9.75208 9.75292H14.5054C14.8336 9.75292 15.0996 9.4869 15.0996 9.15875C15.0996 8.8306 14.8336 8.56458 14.5054 8.56458H9.75208Z",
    fill: "#243677"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15792 12.1296C9.15792 11.8014 9.42393 11.5354 9.75208 11.5354H14.5054C14.8336 11.5354 15.0996 11.8014 15.0996 12.1296C15.0996 12.4577 14.8336 12.7238 14.5054 12.7238H9.75208C9.42393 12.7238 9.15792 12.4577 9.15792 12.1296Z",
    fill: "#243677"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75208 14.5063C9.42393 14.5063 9.15792 14.7723 9.15792 15.1004C9.15792 15.4286 9.42393 15.6946 9.75208 15.6946H11.3365C11.6647 15.6946 11.9307 15.4286 11.9307 15.1004C11.9307 14.7723 11.6647 14.5063 11.3365 14.5063H9.75208Z",
    fill: "#243677"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.921 14.5063C12.5928 14.5063 12.3268 14.7723 12.3268 15.1004C12.3268 15.4286 12.5928 15.6946 12.921 15.6946H14.5054C14.8336 15.6946 15.0996 15.4286 15.0996 15.1004C15.0996 14.7723 14.8336 14.5063 14.5054 14.5063H12.921Z",
    fill: "#243677"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1975 18.0126C14.2643 18.0293 14.3291 18.0532 14.3907 18.084C15.8083 18.7928 17.4762 17.762 17.4762 16.177V7.97042C17.4762 6.65782 16.4122 5.59375 15.0996 5.59375H9.15792C7.84532 5.59375 6.78125 6.65782 6.78125 7.97042V16.177C6.78125 17.762 8.44919 18.7928 9.86681 18.084C9.92839 18.0532 9.99317 18.0293 10.06 18.0126L11.8405 17.5674C12.0298 17.5201 12.2277 17.5201 12.417 17.5674L14.1975 18.0126ZM7.96958 7.97042C7.96958 7.31412 8.50162 6.78208 9.15792 6.78208H15.0996C15.7559 6.78208 16.2879 7.31412 16.2879 7.97042V16.177C16.2879 16.8786 15.5496 17.3349 14.9221 17.0211C14.783 16.9516 14.6367 16.8974 14.4857 16.8597L12.7052 16.4146C12.3267 16.32 11.9308 16.32 11.5523 16.4146L9.77175 16.8597C9.62084 16.8974 9.47451 16.9516 9.33537 17.0211C8.70788 17.3349 7.96958 16.8786 7.96958 16.177V7.97042Z",
    fill: "#243677"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.2680c0a109960fb4f67881397eea7a20.svg";
export { ForwardRef as ReactComponent };